module.exports = __webpack_public_path__ + "img/B.732838b7.svg";